var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#362FD8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.0001,
    cy: 26.0001,
    r: 22.5333,
    fill: "#362FD8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_7333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3335 21.3335C21.3335 20.4052 21.7637 19.515 22.5295 18.8586C23.2953 18.2022 24.3339 17.8335 25.4168 17.8335H26.5835C27.6665 17.8335 28.7051 18.2022 29.4708 18.8586C30.2366 19.515 30.6668 20.4052 30.6668 21.3335C30.7098 22.091 30.5055 22.8419 30.0846 23.4731C29.6638 24.1044 29.0492 24.5818 28.3335 24.8335C27.6178 25.1691 27.0032 25.8056 26.5824 26.6473C26.1615 27.489 25.9572 28.4902 26.0002 29.5002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 34.1665V34.1765",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_7333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.ef4ab70f1d58c27e4a7f9961101887c6.svg";
export { ForwardRef as ReactComponent };